// Historique local (localStorage) des recherches - pas de compte requis.
const KEY = "autopart_ia_history_v1";
const MAX_ENTRIES = 20;

export function getHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function addHistoryEntry(entry) {
  const items = getHistory();
  const normalized = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    created_at: new Date().toISOString(),
    ...entry,
  };
  const dedup = items.filter(
    (e) =>
      !(
        e.plaque === normalized.plaque && e.part_query === normalized.part_query
      ),
  );
  const next = [normalized, ...dedup].slice(0, MAX_ENTRIES);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearHistory() {
  localStorage.removeItem(KEY);
  return [];
}

export function removeHistoryEntry(id) {
  const next = getHistory().filter((e) => e.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}
